import {Typography} from '@mui/material';
import {t} from 'i18next';
import React, {useMemo} from 'react';

interface Props {
  statusType: 'pending' | 'recentylAdded';
}

const stringPath = 'common.project.projectRowStatus.';
const ProjectStatusPill: React.FC<Props> = ({statusType}) => {
  const title = useMemo(() => {
    switch (statusType) {
      case 'pending':
        return t(stringPath + 'pending');
      case 'recentylAdded':
        return t(stringPath + 'recentlyAdded');
      default:
        return '';
    }
  }, [statusType, t]);

  return (
    <div className={`project-status-pill-container ${statusType}`}>
      <Typography className="typo-text subhead3_size">{title}</Typography>
    </div>
  );
};

export default ProjectStatusPill;
